export default __webpack_public_path__ + "static/media/referal-linkedin.6568c031.svg";